import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Grid, mediaBreakpointMixin, token } from '@zillow/constellation';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import SEOFooterSubmenu from './SEOFooterSubmenu.js';

var SEOFooterWrapper = /*#__PURE__*/styled(Grid).withConfig({
  componentId: "sc-1txr3v5-0"
})(["> *{position:relative;text-align:center;@media ", "{&:before{content:' ';width:1px;height:24px;position:absolute;top:12px;right:4px;background:", ";}&:last-of-type{&:before{display:none;}}}}"], mediaBreakpointMixin('lg_gte'), token('colors.gray400'));
var SEOFooter = function SEOFooter(_ref) {
  var submenuItems = _ref.submenuItems;
  return /*#__PURE__*/React.createElement(SEOFooterWrapper, {
    display: "grid",
    gridTemplateColumns: {
      default: 'repeat(auto-fit, minmax(0, 1fr))',
      md_lte: 'repeat(1, minmax(0, 1fr))'
    },
    gap: "md"
  }, submenuItems.map(function (submenuItem) {
    return /*#__PURE__*/React.createElement(SEOFooterSubmenu, _extends({
      key: submenuItem === null || submenuItem === void 0 ? void 0 : submenuItem.label
    }, submenuItem));
  }));
};
SEOFooter.propTypes = process.env.NODE_ENV !== "production" ? {
  submenuItems: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    links: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      src: PropTypes.string,
      target: PropTypes.string
    }))
  })).isRequired
} : {};

/** @component */
var SEOFooter$1 = SEOFooter;

export { SEOFooterWrapper, SEOFooter$1 as default };
